import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const actionsCss = "a11o6i5e";
export const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
const contentCss = "c1kap15v";
export const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const cardButtonCss = "c1nbj8f0";
export const CardButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(cardButtonCss, props.className)} />);
const cardHideLogoCss = "c1ybuddp";
const cardCss = "cknrsqp";
export const Card = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    hideLogo,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cardCss, {
    [cardHideLogoCss]: hideLogo
  }, props.className)} />;
});

require("./card.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./card.js");